import { motion } from "framer-motion";

// Masked line-by-line reveal. Each child string becomes one clipped line.
export default function RevealText({ lines, className = "", delay = 0, stagger = 0.12 }) {
  return (
    <span className={className} aria-label={lines.join(" ")}>
      {lines.map((line, i) => (
        <span key={i} className="reveal-line" aria-hidden="true">
          <motion.span
            className="block"
            initial={{ y: "110%" }}
            animate={{ y: 0 }}
            transition={{
              duration: 1,
              ease: [0.16, 1, 0.3, 1],
              delay: delay + i * stagger,
            }}
          >
            {line}
          </motion.span>
        </span>
      ))}
    </span>
  );
}
